// Libs
import React from 'react';

// Utils

// Components

// Component
const Card = ({ children }) => {
    return (
        <div className='card'>
            {children}
        </div>
    );
};

export default Card;
